export default [
  {
    path: "/",
    redirect: "home",
    component: () => import("@/views/home/home")
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/home"),
    meta: {
      title: "首页",
      keepAlive: false
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index"),
    meta: {
      title: "登录"
    }
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index"),
    meta: {
      title: "注册"
    }
  },
  {
    path: "/classify",
    name: "classify",
    component: () => import("@/views/classify/index"),
    meta: {
      title: "分类",
      keepAlive: true
    }
  },
  {
    path: "/mine",
    name: "mine",
    component: () => import("@/views/mine/index"),
    meta: {
      title: "我的"
    }
  },
  {
    path: "/search",
    name: "search",
    component: () => import("@/views/search/index"),
    meta: {
      title: "搜索",
      keepAlive: true,
      saveSrollTop: true
    }
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import("@/views/detail/index"),
    meta: {
      title: "详情"
    }
  },
  {
    path: "/book",
    name: "book",
    component: () => import("@/views/book/index"),
    meta: {
      title: "书单"
    }
  },
  {
    path: "/accBook",
    name: "accBook",
    component: () => import("@/views/accBook/index"),
    meta: {
      title: "随书资源"
    }
  },
  {
    path: "/cdDetail",
    name: "cdDetail",
    component: () => import("@/views/cdDetail/index"),
    meta: {
      title: "光盘详情"
    }
  },
  {
    path: "/myBook",
    name: "myBook",
    component: () => import("@/views/mine/myBook"),
    meta: {
      title: "我的书单"
    }
  },
  {
    path: "/addBook",
    name: "addBook",
    component: () => import("@/views/mine/addBook"),
    meta: {
      title: "新建书单"
    }
  },
  {
    path: "/user",
    name: "user",
    component: () => import("@/views/mine/user"),
    meta: {
      title: "用户设置"
    }
  },
  {
    path: "/update",
    name: "update",
    component: () => import("@/views/mine/update"),
    meta: {
      title: "修改密码"
    }
  },
  {
    path: "/pdf",
    name: "pdf",
    component: () => import("@/views/pdf/index"),
    meta: {
      title: "pdf预览"
    }
  },
  {
    path: "/iframe",
    name: "iframe",
    component: () => import("@/views/iframe/index"),
    meta: {
      title: "随书资源"
    }
  },
  {
    path: "/bookDetail",
    name: "bookDetail",
    component: () => import("@/views/mine/bookDetail"),
    meta: {
      title: "书单详情"
    }
  },
  {
    path: "/video",
    name: "video",
    component: () => import("@/views/video/index"),
    meta: {
      title: "在线播放"
    }
  },
  {
    path: "/audio",
    name: "audio",
    component: () => import("@/views/audio/index"),
    meta: {
      title: "在线播放"
    }
  },
  {
    path: "/reader",
    name: "reader",
    component: () => import("@/views/reader/index"),
    meta: {
      title: "在线阅读"
    }
  },
  {
    path: "/epub",
    name: "epub",
    component: () => import("@/views/epub/index"),
    meta: {
      title: "在线阅读"
    }
  }
];



// WEBPACK FOOTER //
// ./src/router/routes.js